import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const WaitingRoom = ({
  instituteName,
  sessionTitle,
  estimatedWaitTime = '2-3 minutes',
  position = 1,
  onCancel
}) => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4 md:p-6">
      <div className="w-full max-w-2xl">
        <div className="bg-card rounded-lg shadow-lg p-6 md:p-8 lg:p-12 text-center">
          <div className="w-20 h-20 md:w-24 md:h-24 mx-auto mb-6 bg-primary/10 rounded-full flex items-center justify-center">
            <Icon name="Clock" size={48} color="var(--color-primary)" />
          </div>

          <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground mb-3">
            You're in the Waiting Room
          </h1>

          <p className="text-base md:text-lg text-muted-foreground mb-8">
            Please wait while the host admits you to the session
          </p>

          <div className="bg-muted rounded-lg p-6 mb-8">
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-muted-foreground">Session</span>
                <span className="text-sm font-semibold text-foreground">{sessionTitle}</span>
              </div>
              
              {instituteName && (
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-muted-foreground">Institute</span>
                  <span className="text-sm font-semibold text-foreground">{instituteName}</span>
                </div>
              )}

              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-muted-foreground">Your Position</span>
                <span className="text-sm font-semibold text-primary data-text">#{position}</span>
              </div>

              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-muted-foreground">Estimated Wait</span>
                <span className="text-sm font-semibold text-foreground">{estimatedWaitTime}</span>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-3 h-3 bg-primary rounded-full animate-pulse" />
            <div className="w-3 h-3 bg-primary rounded-full animate-pulse" style={{ animationDelay: '0.2s' }} />
            <div className="w-3 h-3 bg-primary rounded-full animate-pulse" style={{ animationDelay: '0.4s' }} />
          </div>

          <div className="space-y-3">
            <div className="flex items-start gap-3 p-4 bg-primary/5 rounded-lg text-left">
              <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-foreground mb-1">
                  Connection Status: Good
                </p>
                <p className="text-sm text-muted-foreground">
                  Your audio and video are ready. You'll be able to test them once admitted.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 p-4 bg-warning/5 rounded-lg text-left">
              <Icon name="AlertCircle" size={20} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-sm text-muted-foreground">
                  Please keep this window open. You'll be automatically admitted when the host is ready.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-border">
            <Button
              variant="outline"
              onClick={onCancel}
              iconName="X"
              iconPosition="left"
            >
              Leave Waiting Room
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaitingRoom;